(function() {
  vtex.define('shipping/script/component/ShippingOptions',['flight/lib/component', 'shipping/script/setup/extensions', 'shipping/script/mixin/withi18n', 'shipping/script/mixin/withLogisticsInfo', 'shipping/script/mixin/withValidation', 'shipping/templates/shippingOptions', 'shipping/templates/deliveryWindows'], function(defineComponent, extensions, withi18n, withLogisticsInfo, withValidation, shippingOptionsTemplate, deliveryWindowsTemplate) {
    var ShippingOptions;
    ShippingOptions = function() {
      this.defaultAttrs({
        data: {
          shippingOptions: [],
          logisticsInfo: [],
          loading: false,
          multipleSellers: false,
          items: [],
          sellers: [],
          loadingShippingOptions: false
        },
        isScheduledDeliveryAvailable: false,
        pickadateFiles: ['shipping/script/libs/pickadate/picker', 'shipping/script/libs/pickadate/picker-date', 'link!shipping/script/libs/pickadate/classic.css', 'link!shipping/script/libs/pickadate/classic-date.css'],
        shippingOptionSelector: '.shipping-option-item',
        pickadateSelector: '.datepicker',
        pickadateValueSelector: '.scheduled-sla-value',
        selectDeliveryDateSelector: '.scheduled-sla-select',
        pickadateValueContainer: '.scheduled-sla-value-container',
        deliveryWindowsTemplateSelector: '.scheduled-sla-time',
        deliveryWindowSelector: '.delivery-windows input[type=radio]',
        changeSlaSelector: '#change-sla-items-list'
      });
      this.render = function() {
        var data, options, requiredFiles,
          _this = this;
        options = this.attr.renderOptions;
        data = this.attr.data;
        requiredFiles = this.attr.isScheduledDeliveryAvailable ? this.attr.pickadateFiles : [];
        return vtex.curl(requiredFiles, function() {
          if (options && options.template === 'deliveryWindows') {
            data = _this.attr.data.shippingOptions[options.index].selectedSla;
            return dust.render(deliveryWindowsTemplate, data, function(err, output) {
              if (!_this.attr.data.active) {
                return;
              }
              output = $(output).i18n();
              _this.getDeliveryWindowsSelector(options.index).html(output);
              return _this.attr.renderOptions = null;
            });
          } else {
            return dust.render(shippingOptionsTemplate, data, function(err, output) {
              if (!_this.attr.data.active) {
                return;
              }
              output = $(output).i18n();
              _this.$node.html(output);
              _this.$node.find(".shipping-option-item input").focus(function() {
                return $(this).parent().addClass("focus");
              }).blur(function() {
                return $(".shipping-option-item").removeClass("focus");
              });
              if (options != null ? options.focusOnSelectedDelivery : void 0) {
                _this.$node.find(".shipping-option-item input[checked='checked']").focus();
                _this.attr.renderOptions = null;
              }
              if (_this.attr.isScheduledDeliveryAvailable) {
                _this.attr.locale = i18n.lng();
                if (_this.attr.locale !== 'en') {
                  $.extend($.fn.pickadate.defaults, vtex.pickadate[_this.attr.locale]);
                }
                return _.each(_this.attr.data.shippingOptions, function(so) {
                  var picker, _ref, _ref1, _ref2;
                  if (((_ref = so.selectedSla) != null ? _ref.isScheduled : void 0) && _this.getPickadateSelector(so.index).length > 0) {
                    _this.getPickadateSelector(so.index).pickadate({
                      disable: [true].concat(so.selectedSla.deliveryDates),
                      container: '.shipping-option-' + so.index + ' ' + _this.attr.pickadateValueContainer
                    });
                    picker = _this.getPickadateSelector(so.index).pickadate('picker');
                    if (so.selectedSla.deliveryWindow.startDateUtc) {
                      picker.set('select', new Date(so.selectedSla.deliveryWindow.startDateUtc));
                      if ((_ref1 = _this.getSelectDeliveryDateSelector(so.index)) != null) {
                        _ref1.hide();
                      }
                      if ((_ref2 = _this.getPickadateValueSelector(so.index)) != null) {
                        _ref2.text(picker.get('value'));
                      }
                    } else {
                      picker.clear();
                    }
                    return picker.on('set', function(context) {
                      if (context.select) {
                        return _this.trigger('scheduleDateSelected.vtex', [so.index]);
                      }
                    });
                  }
                });
              }
            });
          }
        });
      };
      this.getDeliveryWindowsSelector = function(shippingOptionIndex) {
        return $('.shipping-option-' + shippingOptionIndex + ' ' + this.attr.deliveryWindowsTemplateSelector);
      };
      this.getPickadateSelector = function(shippingOptionIndex) {
        return $('.shipping-option-' + shippingOptionIndex + ' ' + this.attr.pickadateSelector);
      };
      this.getPickadateValueSelector = function(shippingOptionIndex) {
        return $('.shipping-option-' + shippingOptionIndex + ' ' + this.attr.pickadateValueSelector);
      };
      this.getSelectDeliveryDateSelector = function(shippingOptionIndex) {
        return $('.shipping-option-' + shippingOptionIndex + ' ' + this.attr.selectDeliveryDateSelector);
      };
      this.scheduleDateSelected = function(ev, index) {
        var date, picker, shippingOptions, _ref, _ref1;
        picker = this.getPickadateSelector(index);
        date = (_ref = picker.pickadate('get', 'select')) != null ? _ref.obj : void 0;
        shippingOptions = this.attr.data.shippingOptions[index];
        this.updateLogisticsInfoModel(shippingOptions, shippingOptions.selectedSla.id, this.getCheapestDeliveryWindow(shippingOptions, new Date(date)));
        this.getPickadateValueSelector(index).text(picker.pickadate('get', 'value'));
        if ((_ref1 = this.getSelectDeliveryDateSelector(index)) != null) {
          _ref1.hide();
        }
        this.attr.renderOptions = {
          template: 'deliveryWindows',
          index: index
        };
        return this.render();
      };
      this.openPickadateHandler = function(ev, data) {
        var shippingOptionIndex;
        ev.stopPropagation();
        shippingOptionIndex = $(data.el).data('shipping-option');
        return this.openPickadate(shippingOptionIndex);
      };
      this.openPickadate = function(shippingOptionIndex) {
        var picker;
        return picker = this.getPickadateSelector(shippingOptionIndex).pickadate('open');
      };
      this.deliveryWindowSelected = function(ev, data) {
        var deliveryWindow, deliveryWindowIndex, shippingOptionIndex, shippingOptions, sla;
        deliveryWindowIndex = $(data.el).attr('value');
        shippingOptionIndex = $(data.el).data('shipping-option');
        shippingOptions = this.attr.data.shippingOptions[shippingOptionIndex];
        sla = shippingOptions.selectedSla;
        deliveryWindow = sla.deliveryWindowsForDate[deliveryWindowIndex];
        return this.updateLogisticsInfoModel(shippingOptions, sla.id, deliveryWindow);
      };
      this.selectShippingOptionHandler = function(ev, data) {
        var selectedSla, shippingOptionIndex, shippingOptions;
        ev.preventDefault();
        if ($(data.el).hasClass('active')) {
          return;
        }
        selectedSla = $('input', data.el).attr('value');
        shippingOptionIndex = $('input', data.el).data('shipping-option');
        shippingOptions = this.attr.data.shippingOptions[shippingOptionIndex];
        return this.selectShippingOption(shippingOptions, selectedSla);
      };
      this.selectShippingOptionMultipleSellersHandler = function(ev, data) {
        var selectedSla, shippingOptionIndex, shippingOptions;
        ev.preventDefault();
        selectedSla = $(data.el).val();
        shippingOptionIndex = $(data.el).data('shipping-option');
        shippingOptions = this.attr.data.shippingOptions[shippingOptionIndex];
        return this.selectShippingOption(shippingOptions, selectedSla);
      };
      this.selectShippingOption = function(shippingOptions, selectedSla) {
        var _this = this;
        this.updateLogisticsInfoModel(shippingOptions, selectedSla);
        this.attr.data.shippingOptions = this.getShippingOptionsData(this.attr.data.logisticsInfo, this.attr.data.items, this.attr.data.sellers);
        return this.updateShippingOptionsLabels(this.attr.data.shippingOptions).then(function() {
          _this.attr.renderOptions = {
            focusOnSelectedDelivery: true
          };
          return _this.render();
        });
      };
      this.validateShippingOptions = function() {
        var _this = this;
        return _.all(this.attr.data.shippingOptions, function(so) {
          var selector, _ref;
          if ((_ref = so.selectedSla) != null ? _ref.isScheduled : void 0) {
            if (so.selectedSla.deliveryWindow.startDateUtc != null) {
              return true;
            } else {
              selector = _this.getSelectDeliveryDateSelector(so.index);
              selector.trigger('click');
              return false;
            }
          }
          return true;
        });
      };
      this.enable = function(ev, logisticsInfo, items, sellers) {
        var _this = this;
        if (ev != null) {
          ev.stopPropagation();
        }
        this.attr.data.active = true;
        this.attr.data.loadingShippingOptions = false;
        this.attr.data.items = _.map(items, function(item, i) {
          item.index = i;
          return item;
        });
        this.attr.data.logisticsInfo = logisticsInfo;
        this.attr.data.sellers = sellers;
        this.attr.data.shippingOptions = this.getShippingOptionsData(logisticsInfo, this.attr.data.items, sellers);
        return this.updateShippingOptionsLabels(this.attr.data.shippingOptions).then(function() {
          return _this.render();
        });
      };
      this.disable = function(ev) {
        if (ev != null) {
          ev.stopPropagation();
        }
        this.attr.data.active = false;
        return this.$node.html('');
      };
      this.startLoadingShippingOptions = function(ev) {
        if (ev != null) {
          ev.stopPropagation();
        }
        this.attr.data.loadingShippingOptions = true;
        return this.render();
      };
      return this.after('initialize', function() {
        this.on('enable.vtex', this.enable);
        this.on('disable.vtex', this.disable);
        this.on('scheduleDateSelected.vtex', this.scheduleDateSelected);
        this.on('startLoading.vtex', this.startLoadingShippingOptions);
        this.on('click', {
          'shippingOptionSelector': this.selectShippingOptionHandler,
          'deliveryWindowSelector': this.deliveryWindowSelected,
          'pickadateValueContainer': this.openPickadateHandler
        });
        this.on('change', {
          'changeSlaSelector': this.selectShippingOptionMultipleSellersHandler
        });
        this.setValidators([this.validateShippingOptions]);
        return this.setLocalePath('shipping/script/translation/');
      });
    };
    return defineComponent(ShippingOptions, withi18n, withLogisticsInfo, withValidation);
  });

}).call(this);

